import "core-js/modules/es.array.concat.js";
import layoutHeaderAside from "@/layout/header-aside";

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
var _import = require("@/libs/util.import." + process.env.NODE_ENV);

/**
 * 在主框架内显示
 */
var frameIn = [{
  path: "/",
  redirect: {
    name: "index"
  },
  component: layoutHeaderAside,
  children: [
  // 首页
  {
    path: "index",
    name: "index",
    meta: {
      auth: true
    },
    component: _import("system/index")
  },
  // 基本信息 / 城市管理
  {
    path: "/base/city",
    name: "base-city",
    meta: {
      title: "城市管理",
      auth: true
    },
    component: _import("base/city")
  },
  // 基本信息 / 城市管理 / 区域管理
  {
    path: "/base/district",
    name: "base-district",
    meta: {
      title: "区域管理",
      auth: true
    },
    component: _import("base/district")
  },
  // 基本信息 / 城市管理 / 区域管理 / 地标管理
  {
    path: "/base/landmark",
    name: "base-landmark",
    meta: {
      title: "地标管理",
      auth: true
    },
    component: _import("base/landmark")
  },
  // 基本信息 / 总结评分
  {
    path: "/base/summary",
    name: "base-summary",
    meta: {
      title: "总结评分",
      auth: true
    },
    component: _import("base/summary")
  },
  // 基本信息 / 城市管理 / 区域管理 / 商圈管理
  {
    path: "/base/business",
    name: "base-business",
    meta: {
      title: "商圈管理",
      auth: true
    },
    component: _import("base/business")
  },
  // 基本信息 / 城市管理 / 地铁管理
  {
    path: "/base/subway",
    name: "base-subway",
    meta: {
      title: "地铁管理",
      auth: true
    },
    component: _import("base/subway")
  },
  // 基本信息 / 城市管理 / 地铁管理
  {
    path: "/base/subway/station",
    name: "base-subway-station",
    meta: {
      title: "地铁站管理",
      auth: true
    },
    component: _import("base/subwayStation")
  },
  // 基本信息 / 城市管理 / 城市攻略
  {
    path: "/base/city/strategy",
    name: "base-city-strategy",
    meta: {
      title: "城市攻略",
      auth: true
    },
    component: _import("base/cityStrategy")
  },
  // 基本信息 / 租房类型
  {
    path: "/base/renting/type",
    name: "base-renting-type",
    meta: {
      title: "租房类型",
      auth: true
    },
    component: _import("base/rentingType")
  },
  // 基本信息 / 时间类型
  {
    path: "/base/time/type",
    name: "base-time-type",
    meta: {
      title: "时间类型",
      auth: true
    },
    component: _import("base/timeType")
  },
  // 基本信息 / 房源设施
  {
    path: "/base/house/facilities",
    name: "base-house-facilities",
    meta: {
      title: "房源设施",
      auth: true
    },
    component: _import("base/houseFacilities")
  },
  // 基本信息 / 标签管理
  {
    path: "/base/tags",
    name: "base-tags",
    meta: {
      title: "标签管理",
      auth: true
    },
    component: _import("base/tags")
  },
  // 基本信息 / 电话代码
  {
    path: "/base/phone/code",
    name: "base-phone-code",
    meta: {
      title: "电话代码",
      auth: true
    },
    component: _import("base/phoneCode")
  },
  // 基本信息 / 版本管理
  {
    path: "/base/app/version",
    name: "base-app-version",
    meta: {
      title: "版本管理",
      auth: true
    },
    component: _import("base/appVersion")
  },
  // 基本信息 / 社交媒体
  {
    path: "/base/social",
    name: "base-social",
    meta: {
      title: "社交媒体",
      auth: true
    },
    component: _import("base/social")
  },
  // 基本信息 / 短信极速通知
  {
    path: "/base/sms",
    name: "base-sms",
    meta: {
      title: "短信极速通知",
      auth: true
    },
    component: _import("base/sms")
  },
  // 基本信息 / 货币单位
  {
    path: "/base/unit/currency",
    name: "base-unit-currency",
    meta: {
      title: "货币单位",
      auth: true
    },
    component: _import("base/currencyUnit")
  },
  // 基本信息 / 面积单位
  {
    path: "/base/unit/area",
    name: "base-unit-area",
    meta: {
      title: "面积单位",
      auth: true
    },
    component: _import("base/areaUnit")
  },
  // 基本信息 / slogan
  {
    path: "/base/slogan",
    name: "base-slogan",
    meta: {
      title: "Slogan",
      auth: true
    },
    component: _import("base/slogan")
  },
  // 基本信息 / 开机屏
  {
    path: "/base/boot-screen",
    name: "base-boot-screen",
    meta: {
      title: "开机屏",
      auth: true
    },
    component: _import("base/bootScreen")
  },
  // 基本信息 / 商务配置
  {
    path: "/base/business-contact-config",
    name: "base-business-contact-config",
    meta: {
      title: "商务配置",
      auth: true
    },
    component: _import("base/businessContactConfig")
  },
  // 基本信息 / 商务联系人
  {
    path: "/base/business-contact",
    name: "base-business-contact",
    meta: {
      title: "商务联系人",
      auth: true
    },
    component: _import("base/businessContact")
  },
  // 基本信息 / 菜单管理
  {
    path: "/base/menu",
    name: "base-menu",
    meta: {
      title: "菜单管理",
      auth: true
    },
    component: _import("base/menu")
  },
  // 基本信息 / 操作管理
  {
    path: "/base/menu/button",
    name: "base-menu-button",
    meta: {
      title: "操作管理",
      auth: true
    },
    component: _import("base/menuButton")
  },
  // 基本信息 / 操作日志
  {
    path: "/base/operation/log",
    name: "base-operation-log",
    meta: {
      title: "操作日志",
      auth: true
    },
    component: _import("base/operationLog")
  },
  // 运营管理 / 商务合作
  {
    path: "/base/business/cooperation",
    name: "base-business-cooperation",
    meta: {
      title: "商务合作",
      auth: true
    },
    component: _import("base/businessCooperation")
  },
  // 资金管理 / 签约记录
  {
    path: "/capital/sign",
    name: "capital-sign",
    meta: {
      title: "签约记录",
      cache: false,
      auth: true
    },
    component: _import("capital/sign")
  },
  // 资金管理 / 纠纷处理
  {
    path: "/capital/dispute",
    name: "capital-dispute",
    meta: {
      title: "纠纷处理",
      cache: false,
      auth: true,
      code: "contract_dispute"
    },
    component: _import("capital/dispute")
  },
  // 资金管理 / 提现申请
  {
    path: "/capital/withdraw",
    name: "capital-withdraw",
    meta: {
      title: "提现申请",
      cache: false,
      auth: true
    },
    component: _import("capital/withdraw")
  },
  // 资金管理 / 用户流水
  {
    path: "/capital/list",
    name: "capital-list",
    meta: {
      title: "用户流水",
      cache: false,
      auth: true
    },
    component: _import("capital/list")
  },
  // 资金管理 / 汇率管理
  {
    path: "/capital/rate",
    name: "capital-rate",
    meta: {
      title: "汇率管理",
      cache: false,
      auth: true
    },
    component: _import("capital/rate")
  },
  // 订单管理 / 国内签约
  {
    path: "/order/domestic/sign",
    name: "order-domestic-sign",
    meta: {
      title: "线上签约",
      cache: false,
      auth: true
    },
    component: _import("order/sign")
  }, {
    path: "/order/domestic/contract",
    name: "order-domestic-contract",
    meta: {
      title: "国内签约",
      cache: false,
      auth: true
    },
    component: _import("order/domesticContract")
  },
  // 订单管理 / 跨境签约
  {
    path: "/order/foreign/contract",
    name: "order-foreign-contract",
    meta: {
      title: "跨境签约",
      cache: false,
      auth: true
    },
    component: _import("order/foreignContract")
  },
  // 订单管理 / 房源认证
  {
    path: "/order/housing/certification",
    name: "order-housing/certification",
    meta: {
      title: "房源认证",
      cache: false,
      auth: true
    },
    component: _import("order/housingCertification")
  },
  // 订单管理 / 房源推广
  {
    path: "/order/housing/promotion",
    name: "order-housing-promotion",
    meta: {
      title: "房源推广",
      cache: false,
      auth: true
    },
    component: _import("order/housingPromotion")
  },
  // 订单管理 / 短信极速通知
  {
    path: "/order/sms",
    name: "order-sms",
    meta: {
      title: "短信极速通知",
      cache: false,
      auth: true
    },
    component: _import("order/sms")
  },
  // 订单管理 / 品牌充值
  {
    path: "/order/brand",
    name: "order-brand",
    meta: {
      title: "品牌充值",
      cache: false,
      auth: true
    },
    component: _import("order/brand")
  },
  // 订单管理 / 实名认证
  {
    path: "/order/real-name",
    name: "order-real-name",
    meta: {
      title: "实名认证",
      cache: false,
      auth: true
    },
    component: _import("order/realName")
  },
  // 订单管理 / 门票
  {
    path: "/order/tickets",
    name: "order-tickets",
    meta: {
      title: "门票",
      cache: false,
      auth: true
    },
    component: _import("order/tickets")
  },
  // 订单管理 / 退款管理
  {
    path: "/order/refund",
    name: "order-refund",
    meta: {
      title: "退款管理",
      cache: false,
      auth: true
    },
    component: _import("order/refund")
  },
  // 订单管理 / 品牌季度
  {
    path: "/order/vip",
    name: "order-vip",
    meta: {
      title: "品牌季度",
      cache: false,
      auth: true
    },
    component: _import("order/vip")
  },
  // 订单管理 / 会员充值
  {
    path: "/order/member",
    name: "order-member",
    meta: {
      title: "会员充值",
      cache: false,
      auth: true,
      code: "order_membership"
    },
    component: _import("order/member")
  },
  // 订单管理 / 强制实名
  {
    path: "/order/forceRealName",
    name: "order-forceRealName",
    meta: {
      title: "强制实名",
      cache: false,
      auth: true
    },
    component: _import("order/forceRealName")
  },
  // 品牌季度 / 合同管理
  {
    path: "/signing/list",
    name: "signing-list",
    meta: {
      title: "合同管理",
      cache: false,
      auth: true
    },
    component: _import("signing/list")
  },
  // 优惠券管理 / 配置列表
  {
    path: "/coupon/config",
    name: "coupon-config",
    meta: {
      title: "配置列表",
      cache: false,
      auth: true,
      code: "coupon_configure"
    },
    component: _import("coupon/config")
  },
  // 优惠券管理 / 发放明细
  {
    path: "/coupon/record",
    name: "coupon-record",
    meta: {
      title: "发放明细",
      cache: false,
      auth: true
    },
    component: _import("coupon/record")
  },
  // 品牌充值 / 充值用户
  {
    path: "/brand/user",
    name: "brand-user",
    meta: {
      code: "brand_user",
      title: "充值用户",
      cache: false,
      auth: true
    },
    component: _import("brand/user")
  },
  // 品牌充值 / 充值房源
  {
    path: "/brand/apartment",
    name: "brand-apartment",
    meta: {
      code: "brand_list",
      title: "充值房源",
      cache: false,
      auth: true
    },
    component: _import("brand/apartment")
  },
  // 品牌充值 / 充值审核
  {
    path: "/brand/apartment/audit",
    name: "brand-apartment-audit",
    meta: {
      code: "brand_audit",
      title: "充值审核",
      cache: false,
      auth: true
    },
    component: _import("brand/apartmentAudit")
  },
  // 品牌充值 / 账户详情
  {
    path: "/brand/account/detail",
    name: "brand-account-detail",
    meta: {
      title: "账户详情",
      cache: false,
      auth: true
    },
    component: _import("brand/accountDetail")
  },
  // 品牌充值 / 结算记录
  {
    path: "/brand/settlement/:userId?",
    name: "brand-settlement",
    meta: {
      title: "结算记录",
      cache: false,
      auth: true
    },
    component: _import("brand/settlement")
  },
  // 品牌充值 / 资金记录
  {
    path: "/brand/money",
    name: "brand-money",
    meta: {
      title: "资金记录",
      cache: false,
      auth: true
    },
    component: _import("order/brand")
  },
  // 品牌充值 / 收入统计
  {
    path: "/brand/income",
    name: "brand-income",
    meta: {
      title: "收入统计",
      cache: false,
      auth: true
    },
    component: _import("brand/income")
  },
  // 民宿管理 / 民宿用户
  {
    path: "/bnb/user",
    name: "bnb-user",
    meta: {
      title: "民宿用户",
      cache: false,
      auth: true
    },
    component: _import("bnb/user")
  },
  // 民宿管理 / 民宿房源
  {
    path: "/bnb/apartment",
    name: "bnb-apartment",
    meta: {
      title: "民宿房源",
      cache: false,
      auth: true
    },
    component: _import("bnb/apartment")
  },
  // 民宿管理 / 民宿审核
  {
    path: "/bnb/apartment/audit",
    name: "bnb-apartment-audit",
    meta: {
      title: "民宿审核",
      cache: false,
      auth: true
    },
    component: _import("bnb/apartmentAudit")
  },
  // 民宿管理 / 账户详情
  {
    path: "/bnb/account/detail",
    name: "bnb-account-detail",
    meta: {
      title: "账户详情",
      cache: false,
      auth: true
    },
    component: _import("bnb/accountDetail")
  },
  // 民宿管理 / 结算记录
  {
    path: "/bnb/settlement/:userId?",
    name: "bnb-settlement",
    meta: {
      title: "结算记录",
      cache: false,
      auth: true
    },
    component: _import("bnb/settlement")
  },
  // 民宿管理 / 资金记录
  {
    path: "/bnb/money",
    name: "bnb-money",
    meta: {
      title: "资金记录",
      cache: false,
      auth: true
    },
    component: _import("bnb/money")
  },
  // 民宿管理 / 收入统计
  {
    path: "/bnb/income",
    name: "bnb-income",
    meta: {
      title: "收入统计",
      cache: false,
      auth: true
    },
    component: _import("bnb/income")
  },
  // 品牌季度 / 季度用户
  {
    path: "/quarter/user",
    name: "quarter-user",
    meta: {
      code: "quarter_user",
      title: "季度用户",
      cache: false,
      auth: true
    },
    component: _import("quarter/user")
  },
  // 品牌季度 / 季度用户New
  {
    path: "/quarter/userNew",
    name: "quarter-userNew",
    meta: {
      code: "quarter_user",
      title: "季度用户",
      cache: false,
      auth: true
    },
    component: _import("quarter/userNew")
  },
  // 品牌季度 / 季度房源
  {
    path: "/quarter/house",
    name: "quarter-house",
    meta: {
      code: "quarter_list",
      title: "季度房源",
      cache: false,
      auth: true
    },
    component: _import("quarter/house")
  },
  // 品牌季度 / 季度公寓
  {
    path: "/quarter/apartment",
    name: "quarter-apartment",
    meta: {
      code: "quarter_list",
      title: "季度公寓",
      cache: false,
      auth: true
    },
    component: _import("quarter/apartment")
  },
  // 品牌季度 / 季度审核
  {
    path: "/quarter/apartment/audit",
    name: "quarter-apartment-audit",
    meta: {
      code: "quarter_audit",
      title: "季度审核",
      cache: false,
      auth: true
    },
    component: _import("quarter/apartmentAudit")
  },
  // 品牌季度 / 公司名单
  {
    path: "/quarter/company",
    name: "quarter-company",
    meta: {
      title: "公司名单",
      cache: false,
      auth: true,
      code: "quarter_company"
    },
    component: _import("quarter/company")
  },
  // 品牌季度 / 订单记录
  {
    path: "/quarter/orderRecord",
    name: "quarter-orderRecord",
    meta: {
      title: "订单记录",
      cache: false,
      auth: true
    },
    component: _import("quarter/orderRecord")
  },
  // 品牌季度 / 押金订单
  {
    path: "/quarter/deposit",
    name: "quarter-deposit",
    meta: {
      title: "押金订单",
      cache: false,
      auth: true,
      code: "quarter_depositorder"
    },
    component: _import("quarter/deposit")
  },
  // 品牌季度 / 收款记录
  {
    path: "/quarter/paymentRecord",
    name: "quarter-paymentRecord",
    meta: {
      title: "收款记录",
      cache: false,
      auth: true,
      code: "quarter_payment_record"
    },
    component: _import("quarter/paymentRecord")
  },
  // 品牌季度 / 周报
  {
    path: "/quarter/statistics",
    name: "quarter-statistics",
    meta: {
      title: "周报",
      cache: false,
      auth: true
    },
    component: _import("quarter/statistics")
  },
  // 房源推广 / 推广配置
  {
    path: "/promote/config",
    name: "promote-config",
    meta: {
      title: "推广配置",
      cache: false,
      auth: true
    },
    component: _import("promote/config")
  },
  // 房源推广 / 推广配置 V2
  {
    path: "/promote/config/v2",
    name: "promote-config-v2",
    meta: {
      title: "推广配置",
      cache: false,
      auth: true
    },
    component: _import("promote/configV2")
  },
  // 房源推广 / 推广列表
  {
    path: "/promote/list",
    name: "promote-list",
    meta: {
      title: "推广列表",
      cache: false,
      auth: true
    },
    component: _import("promote/list")
  },
  // 房源推广 / 推广列表 V2
  {
    path: "/promote/list/v2",
    name: "promote-list-v2",
    meta: {
      code: "promotion_list",
      title: "推广列表",
      cache: false,
      auth: true
    },
    component: _import("promote/listV2")
  },
  // 房源推广 / 品牌公寓
  {
    path: "/house/vip/list",
    name: "house-vip-list",
    meta: {
      title: "品牌公寓",
      cache: false,
      auth: true
    },
    component: _import("house/vipList")
  },
  // 置顶池 / 置顶池管理
  {
    path: "/top/config",
    name: "top-config",
    meta: {
      title: "置顶池管理",
      cache: false,
      auth: true
    },
    component: _import("top/config")
  },
  // 置顶池 / 置顶池列表
  {
    path: "/top/list/:type/:topType",
    name: "top-list",
    meta: {
      title: "置顶池列表",
      cache: false,
      auth: true
    },
    component: _import("top/list")
  },
  // 置顶池 / 置顶记录
  {
    path: "/top/record",
    name: "top-record",
    meta: {
      title: "置顶记录",
      cache: false,
      auth: true
    },
    component: _import("top/record")
  },
  // 房源管理 / 房源列表
  {
    path: "/house/list",
    name: "house-list",
    meta: {
      code: "house_list",
      title: "房源列表",
      cache: false,
      auth: true
    },
    component: _import("house/list")
  },
  // 房源管理 / 审核列表
  {
    path: "/house/audit",
    name: "house-audit",
    meta: {
      code: "house_audit",
      title: "房源审核",
      cache: false,
      auth: true
    },
    component: _import("house/audit")
  },
  // 房源管理 / 实名认证
  {
    path: "/house/real-name",
    name: "house-real-name",
    meta: {
      code: "house_realname",
      title: "实名认证",
      cache: false,
      auth: true
    },
    component: _import("house/realName")
  },
  // 房源管理 / 认证列表
  {
    path: "/house/auth",
    name: "house-auth",
    meta: {
      code: "house_authenticationlist",
      title: "认证列表",
      cache: false,
      auth: true
    },
    component: _import("house/auth")
  },
  // 房源管理 / 已删房源
  {
    path: "/house/deleted",
    name: "house-deleted",
    meta: {
      title: "已删房源",
      cache: false,
      auth: true
    },
    component: _import("house/deleted")
  },
  // 房源管理 / 签约管理
  {
    path: "/house/sign-contract",
    name: "house-sign-contract",
    meta: {
      code: "house_contract",
      title: "签约管理",
      cache: false,
      auth: true
    },
    component: _import("house/signContract")
  },
  // 房源管理 / 签约管理 / 打印合同
  {
    path: "/house/print-contract",
    name: "house-print-contract",
    meta: {
      title: "打印合同",
      cache: false,
      auth: true
    },
    component: _import("house/contract")
  },
  // 房源管理 / 编辑房源
  {
    path: "/house/update",
    name: "house-update",
    meta: {
      title: "编辑房源",
      cache: false,
      auth: true,
      single: true // tab 只显示一个
    },
    component: _import("house/update")
  },
  // 评论审核
  {
    path: "/comment/audit/lifestyle",
    name: "comment-audit",
    meta: {
      code: "lifestyle_commentaudit",
      title: "评论审核",
      cache: false,
      auth: true
    },
    component: _import("comment/audit")
  }, {
    path: "/comment/audit/used",
    name: "comment-audit",
    meta: {
      code: "swapsale_commentaudit",
      title: "评论审核",
      cache: false,
      auth: true
    },
    component: _import("comment/audit")
  }, {
    path: "/comment/audit/article",
    name: "comment-audit",
    meta: {
      title: "评论审核",
      cache: false,
      auth: true
    },
    component: _import("comment/audit")
  },
  // Lifestyle / Lifestyle列表
  {
    path: "/lifestyle/list",
    name: "lifestyle-list",
    meta: {
      code: "lifestyle_list",
      title: "Lifestyle列表",
      cache: false,
      auth: true
    },
    component: _import("lifestyle/list")
  },
  // Lifestyle / 审核列表
  {
    path: "/lifestyle/audit",
    name: "lifestyle-audit",
    meta: {
      code: "lifestyle_audit",
      title: "lifestyle审核",
      cache: false,
      auth: true
    },
    component: _import("lifestyle/audit")
  },
  // Lifestyle / 推荐列表
  {
    path: "/lifestyle/recommend",
    name: "lifestyle-recommend",
    meta: {
      code: "lifestyle_recommendlist",
      title: "推荐列表",
      cache: false,
      auth: true
    },
    component: _import("lifestyle/recommend")
  },
  // Lifestyle / 草稿列表
  {
    path: "/lifestyle/draft",
    name: "lifestyle-draft",
    meta: {
      title: "草稿列表",
      cache: false,
      auth: true
    },
    component: _import("lifestyle/draft")
  },
  // Lifestyle / 标签管理
  {
    path: "/lifestyle/tag",
    name: "lifestyle-tag",
    meta: {
      title: "标签管理",
      cache: false,
      auth: true
    },
    component: _import("lifestyle/tag")
  },
  // Lifestyle / 评论管理
  {
    path: "/lifestyle/comment",
    name: "lifestyle-comment",
    meta: {
      code: "lifestyle_list_comment",
      title: "评论管理",
      cache: false,
      auth: true
    },
    component: _import("lifestyle/comment")
  },
  // Lifestyle / 活动配置
  {
    path: "/lifestyle/activeConfig",
    name: "lifestyle-activeConfig",
    meta: {
      title: "活动配置",
      cache: false,
      auth: true
    },
    component: _import("lifestyle/activeConfig")
  },
  // Lifestyle / 编辑Lifestyle
  {
    path: "/lifestyle/update",
    name: "lifestyle-update",
    meta: {
      title: "编辑Lifestyle",
      cache: false,
      auth: true,
      single: true // tab 只显示一个
    },
    component: _import("lifestyle/update")
  },
  // 社区管理 / 社区列表
  {
    path: "/community/list",
    name: "community-list",
    meta: {
      code: "community_list",
      title: "社区列表",
      cache: false,
      auth: true
    },
    component: _import("community/list")
  },
  // 社区管理 / 社区详情
  {
    path: "/community/update",
    name: "community-update",
    meta: {
      code: "community_update",
      title: "社区列表",
      cache: false,
      auth: true
    },
    component: _import("community/update")
  },
  // 社区管理 / 社区审核
  {
    path: "/community/audit",
    name: "community-audit",
    meta: {
      code: "community_audit",
      title: "社区审核",
      cache: false,
      auth: true
    },
    component: _import("community/audit")
  },
  // 社区管理 / 社区评论审核
  {
    path: "/community/comment",
    name: "community-comment",
    meta: {
      code: "community_comment",
      title: "评论审核",
      cache: false,
      auth: true
    },
    component: _import("community/comment")
  },
  // 社区管理 / 社区评论审核
  {
    path: "/community/comment",
    name: "community-comment",
    meta: {
      code: "community_comment",
      title: "评论审核",
      cache: false,
      auth: true
    },
    component: _import("community/comment")
  },
  // 社区管理 / 标签管理
  {
    path: "/community/tag",
    name: "community-tag",
    meta: {
      code: "community_tag",
      title: "标签管理",
      cache: false,
      auth: true
    },
    component: _import("community/tag")
  },
  // 社区管理 / 分类管理
  {
    path: "/community/category",
    name: "community-category",
    meta: {
      title: "分类管理",
      cache: false,
      auth: true
    },
    component: _import("community/category")
  },
  // 社区管理 / 模拟推荐
  {
    path: "/community/simulationList",
    name: "community-simulationList",
    meta: {
      title: "模拟推荐",
      cache: false,
      auth: true
    },
    component: _import("community/simulationList")
  },
  // 唯心市集 / 物品列表
  {
    path: "/used/list",
    name: "used-list",
    meta: {
      code: 'swapsale_list',
      title: "物品列表",
      cache: false,
      auth: true
    },
    component: _import("used/list")
  },
  // 唯心市集 / 审核列表
  {
    path: "/used/audit",
    name: "used-audit",
    meta: {
      code: 'swapsale_audit',
      title: "市集审核",
      cache: false,
      auth: true
    },
    component: _import("used/audit")
  },
  // 唯心市集 / 推荐列表
  {
    path: "/used/recommend",
    name: "used-recommend",
    meta: {
      code: 'swapsale_recommendlist',
      title: "推荐列表",
      cache: false,
      auth: true
    },
    component: _import("used/recommend")
  },
  // 唯心市集 / 草稿列表
  {
    path: "/used/draft",
    name: "used-draft",
    meta: {
      title: "草稿列表",
      cache: false,
      auth: true
    },
    component: _import("used/draft")
  },
  // 唯心市集 / 分类列表
  {
    path: "/used/category",
    name: "used-category",
    meta: {
      title: "分类列表",
      cache: false,
      auth: true
    },
    component: _import("used/category")
  },
  // 唯心市集 / 广告位
  {
    path: "/used/ads",
    name: "used-ads",
    meta: {
      title: "广告位",
      cache: false,
      auth: true
    },
    component: _import("used/ads")
  },
  // 唯心市集 / 评论管理
  {
    path: "/used/comment",
    name: "used-comment",
    meta: {
      code: 'swapsale_list_comment',
      title: "评论管理",
      cache: false,
      auth: true
    },
    component: _import("used/comment")
  },
  // 唯心市集 / 编辑物品
  {
    path: "/used/update",
    name: "used-update",
    meta: {
      title: "编辑物品",
      cache: false,
      auth: true,
      single: true // tab 只显示一个
    },
    component: _import("used/update")
  },
  // Banner管理 / PC端
  {
    path: "/banner/pc",
    name: "banner-pc",
    meta: {
      title: "Banner-PC端",
      cache: false,
      auth: true
    },
    component: _import("banner/pc")
  },
  // Banner管理 / 移动端
  {
    path: "/banner/mobile",
    name: "banner-mobile",
    meta: {
      title: "Banner-移动端",
      cache: false,
      auth: true
    },
    component: _import("banner/mobile")
  },
  // Banner管理 / 移动端 / 图片管理
  {
    path: "/banner/mobile/image",
    name: "banner-mobile-image",
    meta: {
      title: "Banner-移动端-图片",
      cache: false,
      auth: true
    },
    component: _import("banner/mobileImage")
  },
  // Banner管理 / 移动端 / 视频管理
  {
    path: "/banner/mobile/video",
    name: "banner-mobile-video",
    meta: {
      title: "Banner-移动端-视频",
      cache: false,
      auth: true
    },
    component: _import("banner/mobileVideo")
  },
  // 活动故事 / 文章分类
  {
    path: "/article/category",
    name: "article-category",
    meta: {
      title: "文章分类",
      cache: false,
      auth: true
    },
    component: _import("article/category")
  },
  // 活动故事 / 故事管理
  {
    path: "/article/story",
    name: "article-story",
    meta: {
      title: "故事管理",
      cache: false,
      auth: true
    },
    component: _import("article/story/list")
  },
  // 活动故事 / 编辑故事
  {
    path: "/article/story/update",
    name: "article-story-update",
    meta: {
      title: "编辑故事",
      cache: false,
      auth: true
    },
    component: _import("article/story/update")
  },
  // 活动故事 / 体验管理
  {
    path: "/article/activity",
    name: "article-activity",
    meta: {
      title: "体验管理",
      cache: false,
      auth: true
    },
    component: _import("article/activity/list")
  },
  // 活动故事 / 编辑体验
  {
    path: "/article/activity/update",
    name: "article-activity-update",
    meta: {
      title: "编辑体验",
      cache: false,
      auth: true
    },
    component: _import("article/activity/update")
  },
  // 活动故事 / 评论管理
  {
    path: "/article/comment",
    name: "article-comment",
    meta: {
      title: "评论管理",
      cache: false,
      auth: true
    },
    component: _import("article/comment")
  },
  // 活动故事 / 公司信息
  {
    path: "/article/company",
    name: "article-company",
    meta: {
      title: "公司信息",
      cache: false,
      auth: true
    },
    component: _import("article/company/list")
  },
  // 活动故事 / 编辑公司信息
  {
    path: "/article/company/update",
    name: "article-company-update",
    meta: {
      title: "公司信息",
      cache: false,
      auth: true
    },
    component: _import("article/company/update")
  },
  // 用户管理 / 管理员列表
  {
    path: "/user/manager",
    name: "user-manager",
    meta: {
      title: "管理员列表",
      cache: false,
      auth: true
    },
    component: _import("user/manager")
  },
  // 用户管理 / 用户列表
  {
    path: "/user/list",
    name: "user-list",
    meta: {
      title: "用户列表",
      cache: false,
      auth: true,
      code: "user_userlist"
    },
    component: _import("user/list")
  },
  // 用户管理 / 会员列表
  {
    path: "/user/member",
    name: "user-member",
    meta: {
      title: "会员列表",
      cache: false,
      auth: true,
      code: "user_memberlist"
    },
    component: _import("user/member")
  },
  // 用户管理 / 品牌季度
  {
    path: "/user/vip",
    name: "user-vip",
    meta: {
      title: "品牌季度",
      cache: false,
      auth: true
    },
    component: _import("user/vip")
  },
  // 用户管理 / 城市大使
  {
    path: "/user/city-master",
    name: "user-city-master",
    meta: {
      title: "城市大使",
      cache: false,
      auth: true,
      code: "user_citymaster"
    },
    component: _import("user/city-master/index")
  },
  // 用户管理 / 认证房东
  {
    path: "/user/auth-landlord",
    name: "user-auth-landlord",
    meta: {
      title: "认证房东",
      cache: false,
      auth: true,
      code: "user_authlandlord"
    },
    component: _import("user/authLandlord")
  },
  // 用户管理 / 城市大使 / 结算历史
  {
    path: "/user/city-master/settlement",
    name: "user-city-master-settlement",
    meta: {
      title: "结算历史",
      cache: false,
      auth: true,
      code: "user_citymaster_settlementrecord"
    },
    component: _import("user/city-master/settlement")
  },
  //用户管理 / 城市大使 / 结算规则
  {
    path: "/user/city-master/settlement-rules",
    name: "user-city-master-settlement-rules",
    meta: {
      title: "结算规则",
      cache: false,
      auth: true,
      code: "user_citymaster_settlement_rules"
    },
    component: _import("user/city-master/settlementRules")
  },
  //用户管理 / 城市大使 / 开发记录
  {
    path: "/user/city-master/invitation-log",
    name: "user-city-master-invitation-log",
    meta: {
      title: "邀请记录",
      cache: false,
      auth: true,
      code: "user_citymaster_invitation_log"
    },
    component: _import("user/city-master/invitationLog")
  },
  // 用户管理 / 城市大使 / 邀请审核
  {
    path: "/user/city-master/audit",
    name: "user-city-master-audit",
    meta: {
      title: "邀请审核",
      cache: false,
      auth: true,
      code: "user_citymaster_audit"
    },
    component: _import("user/city-master/audit")
  },
  // 用户管理 / 实名列表
  {
    path: "/user/real-name",
    name: "user-real-name",
    meta: {
      title: "实名列表",
      cache: false,
      auth: true
    },
    component: _import("user/realName")
  },
  // 用户管理 / 强制实名
  {
    path: "/user/force-real-name",
    name: "user-force-real-name",
    meta: {
      title: "强制实名",
      cache: false,
      auth: true,
      code: "user_forcerealname"
    },
    component: _import("user/forceRealName")
  },
  // 用户管理 / 待观察用户
  {
    path: "/user/observed",
    name: "user-observed",
    meta: {
      title: "待观察用户",
      cache: false,
      auth: true
    },
    component: _import("user/observed")
  },
  // 用户管理 / 换绑记录
  {
    path: "/user/phone-update-record",
    name: "user-phone-update-record",
    meta: {
      title: "换绑记录",
      cache: false,
      auth: true
    },
    component: _import("user/phoneUpdateRecord")
  },
  // 用户管理 / 设备ID
  {
    path: "/user/deviceId",
    name: "user-deviceId",
    meta: {
      title: "设备ID",
      cache: false,
      auth: true,
      code: "user_deviceid"
    },
    component: _import("user/deviceId")
  },
  // 用户管理 / IP记录
  {
    path: "/user/ip/log",
    name: "user-ip-log",
    meta: {
      title: "IP记录",
      cache: false,
      auth: true
    },
    component: _import("user/ip")
  },
  // 用户管理 / 账号注销
  {
    path: "/user/logout",
    name: "user-logout",
    meta: {
      title: "账号注销",
      cache: false,
      auth: true,
      code: "user_accountdeletion"
    },
    component: _import("user/logout")
  },
  // 用户管理 / 新增用户
  {
    path: "/user/add",
    name: "user-add",
    meta: {
      title: "新增用户",
      auth: true,
      code: "user_userlist"
    },
    component: _import("user/add")
  },
  // 用户管理 / 重置密码
  {
    path: "/user/set/password",
    name: "user-set-password",
    meta: {
      title: "重置密码",
      auth: true,
      code: "user_userlist"
    },
    component: _import("user/setPassword")
  },
  // 用户管理 / 编辑用户
  {
    path: "/user/update",
    name: "user-update",
    meta: {
      title: "编辑用户",
      cache: false,
      auth: true,
      single: true // tab 只显示一个
    },
    component: _import("user/update")
  },
  // 客户咨询 / 咨询列表
  {
    path: "/consult/list",
    name: "consult-list",
    meta: {
      title: "咨询列表",
      cache: false,
      auth: true,
      code: "consult_list_detail"
    },
    component: _import("consult/list")
  },
  // 客户咨询 / 咨询详情
  {
    path: "/consult/detail",
    name: "consult-detail",
    meta: {
      title: "咨询详情",
      auth: true,
      code: "consult_list_detail"
    },
    component: _import("consult/detail")
  },
  // 客户咨询 / 咨询分类
  {
    path: "/consult/classify",
    name: "consult-classify",
    meta: {
      title: "咨询分类",
      cache: false,
      auth: true
    },
    component: _import("consult/classify")
  },
  // 客户咨询 / 常见问题
  {
    path: "/consult/commonProblem",
    name: "consult-common-problem",
    meta: {
      title: "常见问题",
      cache: false,
      auth: true,
      code: "consult_FAQ"
    },
    component: _import("consult/commonProblem")
  },
  // 客户咨询 / 常见问题二级
  {
    path: "/consult/commonProblemSub",
    name: "consult-common-problem-sub",
    meta: {
      title: "常见问题",
      auth: true,
      code: "consult_FAQ"
    },
    component: _import("consult/commonProblemSub")
  },
  // IM管理 / IM聊天
  {
    path: "/im/list",
    name: "im-list",
    meta: {
      title: "IM聊天",
      cache: false,
      auth: true
    },
    component: _import("im/list")
  },
  // IM管理 / IM搜索
  {
    path: "/im/search",
    name: "im-search",
    meta: {
      title: "IM搜索",
      cache: false,
      auth: true,
      code: "im_search"
    },
    component: _import("im/search")
  },
  // IM管理 / IM监测
  {
    path: "/im/monitor",
    name: "im-monitor",
    meta: {
      title: "IM监测",
      cache: false,
      auth: true,
      code: "im_monitor"
    },
    component: _import("im/monitor")
  },
  // IM管理 / 会话列表
  {
    path: "/im/conversation",
    name: "im-conversation",
    meta: {
      title: "IM会话列表",
      cache: false,
      auth: true
    },
    component: _import("im/conversation")
  },
  // IM管理 / 聊天记录
  {
    path: "/im/chat/record",
    name: "im-chat-record",
    meta: {
      title: "聊天记录",
      cache: false,
      auth: true
    },
    component: _import("im/chatRecord")
  },
  // IM管理 / 聊天
  {
    path: "/im/chat",
    name: "im-chat",
    meta: {
      title: "聊天记录",
      cache: false,
      auth: true,
      code: "im_chat"
    },
    component: _import("im/chat")
  },
  // IM管理 / 群发消息
  {
    path: "/im/group-send/message",
    name: "im-group-send-message",
    meta: {
      title: "群发消息",
      cache: false,
      auth: true,
      code: "im_blast"
    },
    component: _import("im/groupSendMessage")
  }, {
    path: "/im/push",
    name: "im-push",
    meta: {
      title: "系统推送",
      cache: false,
      auth: true
    },
    component: _import("im/push")
  },
  // 投诉管理 / 投诉类型
  {
    path: "/complaint/type",
    name: "complaint-type",
    meta: {
      title: "投诉分类",
      cache: false,
      auth: true
    },
    component: _import("complaint/type")
  },
  // 投诉管理 / 投诉列表
  {
    path: "/complaint/listOld",
    name: "complaint-listOld",
    meta: {
      code: "complaint_listOld",
      title: "投诉列表（旧）",
      cache: false,
      auth: true
    },
    component: _import("complaint/listOld")
  },
  // 投诉管理 / 投诉列表
  {
    path: "/complaint/list",
    name: "complaint-list",
    meta: {
      code: "complaint_list",
      title: "投诉列表",
      cache: false,
      auth: true
    },
    component: _import("complaint/list")
  },
  // 投诉管理 / 一键投诉
  {
    path: "/complaint/quickList",
    name: "quick-list",
    meta: {
      code: "complaint_list",
      title: "一键投诉",
      cache: false,
      auth: true
    },
    component: _import("complaint/quickList")
  },
  // 投诉管理 / 意见反馈
  {
    path: "/complaint/feedback",
    name: "complaint-feedback",
    meta: {
      code: "complaint_suggestions",
      title: "意见反馈",
      cache: false,
      auth: true
    },
    component: _import("complaint/feedback")
  },
  // 系统 前端日志
  {
    path: "log",
    name: "log",
    meta: {
      title: "前端日志",
      auth: true
    },
    component: _import("system/log")
  },
  // 刷新页面 必须保留
  {
    path: "refresh",
    name: "refresh",
    hidden: true,
    component: _import("system/function/refresh")
  },
  // 页面重定向 必须保留
  {
    path: "redirect/:route*",
    name: "redirect",
    hidden: true,
    component: _import("system/function/redirect")
  },
  // 数据统计 / 好友助力
  {
    path: "/statistics/assist",
    name: "statistics-assist",
    meta: {
      title: "好友助力",
      cache: false,
      auth: true
    },
    component: _import("statistics/assist")
  }]
}];

/**
 * 在主框架之外显示
 */
var frameOut = [
// 登录
{
  path: "/login",
  name: "login",
  component: _import("system/login")
},
// 打印合同
{
  path: "/print-contract",
  name: "print-contract",
  component: _import("house/contract")
}];

/**
 * 错误页面
 */
var errorPage = [{
  path: "*",
  name: "404",
  component: _import("system/error/404")
}];

// 导出需要显示菜单的
export var frameInRoutes = frameIn;

// 重新组织后导出
export default [].concat(frameIn, frameOut, errorPage);